// extracted by mini-css-extract-plugin
export default {"GoBack":"EmailRegisterForm_GoBack__DOguh"};